import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores reprehenderit dolorem corrupti illum aut explicabo magni quisquam dolore. Hic, corporis iste ipsam unde quod aliquid ratione aspernatur magnam enim, sequi, sint recusandae mollitia. Quia cupiditate corporis corrupti iusto..',
    name: 'Harsh Thakur',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review:  'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam dolorum in voluptate praesentium fugiat libero error. Inventore nobis eos vitae, voluptatem, maiores voluptas, assumenda soluta consequatur corporis aliquid quam nulla voluptates aspernatur. Molestias nam enim quam tenetur.',
    name: 'Shivam Kumar',
    status: 'ATHLETE'
  },
  {
    image : image3,
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia molestiae dignissimos vero fugit tempora quibusdam voluptatibus nesciunt. Quos, sequi veritatis, facere quo nulla iste a perferendis sit autem quam deleniti minus. Dolorem, qui. Quam ratione rerum repudiandae porro earum similique?',
    name: 'Omkar Pal',
    status: "STUDENT" 
  }
];
